import type * as ReactRouter from "react-router";
import { PricingPage } from "~/app/components/landing/pricing-page";
import { t } from "~/app/i18n";

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("Pricing.metaTitle") },
  { name: "description", content: t("Pricing.metaDescription") },
];

export default function PricingPL() {
  return <PricingPage locale="pl" />;
}
